import axios from "axios";
import { z } from "zod";

import LocalStorageSvc from "./localStorageSvc";

// Holidays data returns in a format like:
// {
//     "1483196400": "元日",
//     "1483282800": "元日 振替休日",
//     "1483887600": "成人の日",
// }
const holidaysSchema = z.record(z.string(), z.string());

type Holidays = z.infer<typeof holidaysSchema>;

/**
 * Fetches Japanese holidays from a third-party API and caches them via LocalStorageSvc.
 */
export default class HolidaysSvc {
  static async getHolidays(year: number) {
    let holidays = await this.getHolidaysFromCache(year);

    if (!holidays) {
      holidays = await this.fetchHolidays(year);
      this.setCacheHolidays(year, holidays);
    }

    return holidays;
  }

  private static async fetchHolidays(year: number): Promise<Holidays> {
    const url = `https://holidays-jp.github.io/api/v1/${year}/datetime.json`;
    const response = await axios.get(url);

    const holidays = holidaysSchema.parse(response.data);
    return holidays;
  }

  private static async getHolidaysFromCache(
    year: number
  ): Promise<Holidays | null> {
    const cacheKey = this.generateCacheKey(year);
    const holidays = LocalStorageSvc.getItem(cacheKey, holidaysSchema);
    return holidays;
  }

  private static setCacheHolidays(year: number, holidays: Holidays) {
    const cacheKey = this.generateCacheKey(year);
    LocalStorageSvc.setItem(cacheKey, holidays);
  }

  private static generateCacheKey(year: number): string {
    return `ac-holidays-${year}`;
  }
}
